import { Provider } from '@angular/core';
import {
  TASK_MANAGEMENT_STORE,
  resolveTaskManagementStoreMode
} from './task-management-store.interface';
import { TaskManagementMockStore } from './task-management-mock-store.service';
import { TaskManagementFirestoreStore } from './task-management-firestore-store.service';

export function provideTaskManagementStore(): Provider[] {
  return [
    TaskManagementMockStore,
    TaskManagementFirestoreStore,
    {
      provide: TASK_MANAGEMENT_STORE,
      useFactory: (mock: TaskManagementMockStore, firestore: TaskManagementFirestoreStore) =>
        resolveTaskManagementStoreMode() === 'mock' ? mock : firestore,
      deps: [TaskManagementMockStore, TaskManagementFirestoreStore]
    }
  ];
}
